import { render, staticRenderFns } from "./KeyEmail.vue?vue&type=template&id=8a88b85a&scoped=true&"
import script from "./KeyEmail.vue?vue&type=script&lang=js&"
export * from "./KeyEmail.vue?vue&type=script&lang=js&"
import style0 from "./KeyEmail.vue?vue&type=style&index=0&id=8a88b85a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a88b85a",
  null
  
)

export default component.exports